import { Component, ViewChild, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { AppStateService } from './core/services/app-state.service';
import { Router, NavigationStart } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from './core/services/auth.service';
import { AppProfile } from './shared/app-profile/app-profile';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './core/services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy {
  isDashboardPage: boolean;
  title = 'material-responsive-sidenav';
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;
  isMobile= true;
  isCollapsed = true;
  isLoading = false;
  private loaderSub: Subscription;
  constructor(
    private appState: AppStateService,
    public router: Router,
    appProfile: AppProfile,
    private observer: BreakpointObserver,
    private authService: AuthService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) {
    translate.addLangs(['en-US']);
    translate.setDefaultLang('en-US');
    // the lang to use, switch here when new lands are added
    appProfile.onProfileChange.subscribe(() => {
      this.translate.use('en-US');
    });

    appState.getIsInDashboardPage().subscribe(result => {
      if (result) {
        this.isDashboardPage = true;
      }
    });
  }

  ngOnInit() {
    this.observer.observe(['(max-width: 800px)']).subscribe((screenSize) => {
      if(screenSize.matches){
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
    this.loaderSub = this.loaderService.loading$.subscribe(loading => {
      this.isLoading = loading;
      this.cdr.detectChanges();
    });
  }

  toggleMenu() {
    if(this.isMobile){
      this.sidenav.toggle();
      this.isCollapsed = false;
    } else {
      this.sidenav.open();
      this.isCollapsed = !this.isCollapsed;
    }
  }

  signout() {
    if (this.appState.getIsFilterPanelOpen()) {
        this.appState.toggleFilterPanel$.emit();
    }
    this.authService.logout();
  }

  @HostListener('window:unload', ['$event'])
  onUnload(event: Event) {
    // Use sendBeacon to notify backend to logout session
    try {
      this.authService.logout();
    } catch (e) {
      // Fallback: optionally clear tokens from storage
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
    }
  }

  ngOnDestroy() {
    this.loaderSub?.unsubscribe();
  }
}
